import React, { Fragment } from 'react';
import { IconButton } from 'moar-interactive-shared';
import ReduceIcon from './../../Icons/icon-reduce.svg?react';
import PlusIcon from './../../Icons/icon-plus.svg?react';
import MinusIcon from './../../Icons/icon-minus.svg?react';

const ExplorerControls = (props) => {
  const { closeExplorer } = props;
  return (
    <Fragment>
      <div className="panZoomModule__close">
        <IconButton icon={<ReduceIcon />} handleClick={() => closeExplorer()} />
      </div>

      <div className="controls">
        <IconButton icon={<PlusIcon />} handleClick={() => props.panZoom.zoomIn()} />
        <IconButton icon={<MinusIcon />} handleClick={() => props.panZoom.zoomOut()} />
      </div>
    </Fragment>
  );
};
export default ExplorerControls;
